<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col style="line-height: 60px;">
          <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main style="height:100%; margin-bottom:60px;">
      <el-table
        :data="withdrawApplications"
        tooltip-effect="dark"
        style="width: 100%"
        border
        v-loading="loading"
      >
        <el-table-column :label="generateCustomizeString('time')" prop="created_at">
          <template slot-scope="scope">{{scope.row.created_at | toLocalTime}}</template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('shopLogo')" scope="scope">
          <template slot-scope="scope">
            <img :src="scope.row.shop.shop_logo_url" style="width: 7rem;" />
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('shopName')" prop="shop.display_shop_name"></el-table-column>
        <el-table-column :label="generateCustomizeString('merchantContactPerson')">
          <template slot-scope="scope">
            <span>{{ scope.row.shop.merchant_name }}</span>
            <br />
            <span>{{ scope.row.shop.merchant_contact_phone }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('withdrawAmount')" prop="amount">
          <template slot-scope="scope">
            <span>NZD ${{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('balance')" prop="shop.wallet.balance">
          <template slot-scope="scope">
            <span>{{scope.row.shop.wallet.balance | formatPrice }}</span>
            <br />
            <el-button
              type="text"
              style="padding: 0;"
              @click="viewHistory(scope.row.shop.id)"
            >{{ generateCustomizeString('viewDetail') }}</el-button>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('status')" prop="status_name"></el-table-column>
        <el-table-column :label="generateCustomizeString('operate')">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="viewApplication(scope.$index)"
            >{{ generateCustomizeString('view') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-dialog :title="generateCustomizeString('createRole')" :visible.sync="createDialogVisiable" width="40%" :append-to-body="true">
        <el-form ref="form" :model="form" :rules="rules" label-width="25%" class="detailForm">
          <el-form-item label="name" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="description" prop="description">
            <el-input v-model="form.description"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onConfirmCreate">{{generateCustomizeString('create')}}</el-button>
            <el-button @click="onCancel">{{generateCustomizeString('cancel')}}</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>-->

      <!-- 余额明细弹窗 -->
      <el-dialog
        :title="generateCustomizeString('shippingAddress')"
        :visible.sync="dialogTableVisible"
      >
        <el-table :data="gridData">
          <el-table-column property="date" :label="generateCustomizeString('date')" width="150"></el-table-column>
          <el-table-column property="name" :label="generateCustomizeString('name')" width="200"></el-table-column>
          <el-table-column property="address" :label="generateCustomizeString('address')"></el-table-column>
        </el-table>
      </el-dialog>
    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="currentTotal"
      ></el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'WithdrawList',
  data() {
    return {
      loading: false,
      withdrawApplications: [],
      currentPage: 1,
      currentTotal: 0,
      pageSize: 15
    }
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      this.fetchWithdrawApplications(this.currentPage)
    },
    handleCurrentChange(val) {
      this.fetchWithdrawApplications(val)
    },
    fetchWithdrawApplications(page) {
      this.loading = true
      request({
        url: 'agent/applications',
        method: 'get',
        params: {
          page: page,
          page_size: this.pageSize
        }
      })
        .then(res => {
          if (res.status === 0) {
            const data = res.data
            const meta = res.meta
            const tmpData = data.map(obj => {
              // obj.created_at = obj.created_at.replace(/-/g, '/')
              // obj.created_at = dayjs(new Date(obj.created_at + ' UTC')).format(
              //   'YYYY-M-D HH:mm:ss'
              // )
              obj.amount = parseFloat((obj.amount * 100) / 10000).toFixed(2)
              return obj
            })
            this.withdrawApplications = tmpData
            console.log(this.withdrawApplications)
            this.currentPage = meta.current_page
            this.currentTotal = meta.total
          }
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    viewApplication(index) {
      this.$router.push({
        name: 'withdrawDetail',
        params: {
          applicationId: this.withdrawApplications[index].id
        }
      })
    },
    viewHistory(agentId) {
      console.log(agentId)
      this.$router.push({
        name: 'walletHistory',
        params: {
          agentId: agentId
        }
      })
    }
  },
  created: function() {
    this.fetchWithdrawApplications(this.currentPage)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
